;(() => {
  const doc = $(document)

  const fixer = () => {
    doc.trigger("fixer")
  }

  // initial, when page ready
  $(fixer)

  // on resize
  $(window).on("resize", fixer)

  // on scroll:
  // - native listener with { passive: true } (jQuery delegation cannot be passive)
  // - coalesce scroll bursts to at most one fire per frame via rAF
  // - plus one trailing fire after scroll ends so layout-sensitive consumers
  //   settle on final scroll position
  const FINISH_STEP_DELAY = 70
  let rafId = 0
  let trailingTimeout = null

  const runFixer = () => {
    rafId = 0
    fixer()
  }

  document.addEventListener(
    "scroll",
    () => {
      if (rafId === 0) {
        rafId = requestAnimationFrame(runFixer)
      }
      clearTimeout(trailingTimeout)
      trailingTimeout = setTimeout(fixer, FINISH_STEP_DELAY)
    },
    { passive: true },
  )

  // Per-selector state shared across all instances with the same selector.
  // Multiple `.fixer()` calls can register against one selector (e.g. the
  // offers_show page binds both the main container and its footer under
  // "place-search-inner"); they all read/write the same `wasFixed` so the
  // state-change guard stays consistent whichever listener runs last in a tick.
  const stateBySelector = new Map()
  const getState = (selector) => {
    let state = stateBySelector.get(selector)
    if (!state) {
      state = { wasFixed: null }
      stateBySelector.set(selector, state)
    }
    return state
  }

  // A Turbo morph re-syncs `<body class>` from the server render, which never
  // carries the runtime `body_<selector>-fixed` classes. Forget the last known
  // state so the next run re-asserts the class and re-fires fixer:fixed /
  // fixer:released for the listeners that mirror it onto their own elements.
  document.addEventListener("turbo:render", () => {
    stateBySelector.forEach((state) => {
      state.wasFixed = null
    })
    fixer()
  })

  $.fn.fixer = function fixerFn(selector, margin, watchPosition = false) {
    const el = $(this)
    if (!el.length) {
      return () => {}
    }

    const body = $("body")
    let fixedPos = el.offset().top - margin
    const state = getState(selector)
    // null forces the first run to always dispatch the correct initial state,
    // even when another instance for the same selector has already primed it
    state.wasFixed = null

    const fixerListener = () => {
      const isFixed = window.pageYOffset > fixedPos
      const changed = isFixed !== state.wasFixed

      if (changed) {
        // Fire BEFORE toggling the body class so listeners can read the
        // element's in-flow geometry (e.g. to reserve its height as a CSS
        // variable). Once the class flips, the element typically becomes
        // `position: fixed` and that measurement is no longer possible.
        if (isFixed) {
          doc.trigger("fixer:will-fix", selector)
        }
        state.wasFixed = isFixed
        window.HB.Memo.toggleClass(body, `body_${selector}-fixed`, isFixed)
      }

      // keep the reference point fresh while released, so layout shifts above
      // the element don't leave us with a stale threshold. Must run AFTER
      // toggleClass so el.offset() reads the element's natural (non-fixed)
      // document position rather than ≈pageYOffset while still fixed.
      if (!isFixed && watchPosition && !body.hasClass("noscroll")) {
        fixedPos = el.offset().top - margin
      }

      if (changed) {
        doc.trigger(isFixed ? "fixer:fixed" : "fixer:released", selector)
      }
    }

    doc.on("fixer", fixerListener)
    fixerListener()

    return () => {
      doc.off("fixer", fixerListener)
    }
  }
})()
